import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useTheme } from '@mui/material';
import { tertiaryHoverSx } from '../../styles/Global.style';

export const Back = ({ fontSize = 'medium', sx }) => {
  const theme = useTheme();

  return (
    <ChevronLeftIcon
      fontSize={fontSize}
      sx={{ ...tertiaryHoverSx(theme), ...sx }}
    />
  );
};
